import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { EXPO_PHOTOS } from "@/data";

export default function Gallery() {
  return (
    <section id="gallery" className="relative bg-ink py-24 md:py-32" data-testid="gallery">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end"
        >
          <div className="max-w-2xl">
            <span className="overline text-orange">Event Highlights · Mysore 2026</span>
            <h2 className="mt-4 font-display text-4xl font-semibold tracking-tighter text-white sm:text-5xl lg:text-6xl">
              A first for Mysore, <span className="text-chrome">delivered.</span>
            </h2>
            <p className="mt-5 font-sans text-sm leading-relaxed text-muted-foreground md:text-base">
              Two days, major CCTV &amp; surveillance brands, and a packed hall at Arcor Hotels.
              Thank you to everyone who visited KevalTek Expo.
            </p>
          </div>
          <div className="flex items-center gap-2 font-mono-tech text-xs uppercase tracking-[0.2em] text-muted-foreground">
            <Camera className="h-4 w-4 text-orange" /> {EXPO_PHOTOS.length} moments
          </div>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12">
          {EXPO_PHOTOS.map((p, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden rounded-sm border border-white/10 ${p.span}`}
              data-testid={`gallery-photo-${i}`}
            >
              <div className="aspect-[16/10] w-full overflow-hidden">
                <img
                  src={p.url}
                  alt={p.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
              </div>
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-transparent opacity-80" />
              <figcaption className="absolute bottom-0 left-0 right-0 flex items-center gap-3 p-5">
                <span className="h-px w-6 shrink-0 bg-orange transition-all duration-500 group-hover:w-10" />
                <span className="font-sans text-sm text-white">{p.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
